import { NotificationType } from "@/types/Notifications.types"
import type { NotificationCenterTypeFilter } from "@/types/NotificationCenter.types"

/** Types présents en base (colonne `notifications.type`). */
export const NOTIFICATION_CENTER_DB_TYPES = [
  NotificationType.NEW_ATTRIBUTE,
  NotificationType.GOOGLE_ACTION_REQUIRED,
  NotificationType.REVIEW,
  NotificationType.TIC,
  NotificationType.GOOGLE_MISSING_PERMISSION,
  NotificationType.REMOVE_ATTRIBUTE,
  NotificationType.FACEBOOK_MISSING_PERMISSION,
  NotificationType.SYNC_GOOGLE_ADDRESS,
  NotificationType.FACEBOOK_CHANGED_PASSWORD,
  NotificationType.FACEBOOK_UNCONFIRMED_USER,
] as const

export const NOTIFICATION_CENTER_SYNC_TYPES = new Set<NotificationType>([
  NotificationType.SYNC_GOOGLE_ADDRESS,
  NotificationType.GOOGLE_MISSING_PERMISSION,
  NotificationType.GOOGLE_ACTION_REQUIRED,
  NotificationType.FACEBOOK_MISSING_PERMISSION,
  NotificationType.FACEBOOK_CHANGED_PASSWORD,
  NotificationType.FACEBOOK_UNCONFIRMED_USER,
])

export const NOTIFICATION_CENTER_LOCAL_NETWORK_TYPES = new Set<NotificationType>([
  NotificationType.TIC,
])

export const NOTIFICATION_CENTER_OTHER_TYPES = new Set<NotificationType>([
  NotificationType.NEW_ATTRIBUTE,
  NotificationType.REMOVE_ATTRIBUTE,
])

export function matchesNotificationCenterTypeFilter(
  notificationType: NotificationType | undefined,
  filter: NotificationCenterTypeFilter
): boolean {
  if (filter === "all") {
    return true
  }

  if (filter === "solicitations") {
    return false
  }

  switch (filter) {
    case "review":
      return notificationType === NotificationType.REVIEW
    case "sync":
      return notificationType !== undefined && NOTIFICATION_CENTER_SYNC_TYPES.has(notificationType)
    case "local_network":
      return notificationType !== undefined && NOTIFICATION_CENTER_LOCAL_NETWORK_TYPES.has(notificationType)
    case "other":
      if (!notificationType) {
        return true
      }
      if (notificationType === NotificationType.REVIEW) {
        return false
      }
      if (NOTIFICATION_CENTER_SYNC_TYPES.has(notificationType)) {
        return false
      }
      if (NOTIFICATION_CENTER_LOCAL_NETWORK_TYPES.has(notificationType)) {
        return false
      }
      return true
    default:
      return true
  }
}
